import Gravatar from 'react-gravatar';

import { Avatar } from '@mantine/core';

import { Md5 } from 'ts-md5';

import { useAuth } from '@/contexts';

interface UserAvatarProps {
  size?: string;
}
export function UserAvatar({ size = 'xl' }: Readonly<UserAvatarProps>) {
  const { user } = useAuth();
  const hashEmail = (email: string) => {
    return Md5.hashStr(email);
  };
  return (
    <Avatar color="blue" radius="sm" size={size}>
      <Gravatar md5={hashEmail(user?.email || '')} default="identicon" />
    </Avatar>
  );
}
